export default __webpack_public_path__ + "static/media/m17.b6d42b61.jpg";